export function getSymbolBasedOnvalue(value) {
  if (!value) {
    return '';
  }

  if (value < 0) {
    return '-';
  } else {
    return '+';
  }
}
